import React from 'react'
import Button from './Button'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  joinPVS = () => {
    const url = `https://app.playvs.com/sign-up/`
    window.open(url, '_blank')
  }

  render() {
    return (
      <div className="intro intro--shorten">
        <div className="container">
          <div className="intro__content">
            <h1>Player Pricing</h1>
            <p>
              PlayVS season passes give players access to all features, perks and benefits of our esports
              program. Passes may be subsidized by schools or paid for by parents.
            </p>
          </div>
          <div className="pricebox">
            <h4>Season Pass</h4>
            <div className="price">
              <div>64</div>
            </div>
            <p>
              Per student, per season <br />
              One time payment
            </p>
            <div className="pricebox__CTA">
              <Button type="button" className="btn btn__primary" text="Get started" onClick={this.joinPVS} />
            </div>
          </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroPricing.js